import React from 'react';
import { Link } from 'react-router-dom';
import styles from './styles.module.css';

const Button = ({
  type = 'button',
  color = 'blue',
  text,
  onClick,
  disabled = false,
  size = 'medium',
  linkType = 'internal',
  linkTo,
  newTab = false,
}) => {
  const className = `${styles.button} ${styles[color]} ${styles[size]}`;

  switch (type) {
    case 'button':
      return (
        <button className={className} onClick={onClick} disabled={disabled} type='button'>
          {text}
        </button>
      );
    case 'link':
      switch (linkType) {
        case 'internal':
          return (
            <Link className={className} to={linkTo} onClick={onClick}>
              {text}
            </Link>
          );
        case 'external':
          return (
            <a
              className={className}
              href={linkTo}
              rel='noopener noreferrer'
              onClick={onClick}
              target={newTab ? '_blank' : undefined}
            >
              {text}
            </a>
          );
      }
  }
};

export default Button;
